import React, { useState } from "react";
import {
    Box,
    Modal,
    Typography,
    IconButton,
    Button,
} from "@mui/material";
import { Close, WarningAmberRounded, OutlinedFlag } from "@mui/icons-material";
import "./style.css";
import dayjs from "dayjs";
import { useReportFeedbackMutation } from "pages/manageReviews/service";
import CustomTextArea from "components/Fileds/CustomTextArea";
import CustomSelect from "components/Fileds/CustomSelect";

const reportOptions = [
    { value: "Misleading / False info", label: "Misleading / False info" },
    { value: "Inappropriate language", label: "Inappropriate language" },
    { value: "Spam / Fake review", label: "Spam / Fake review" },
    { value: "Competitor sabotage", label: "Competitor sabotage" },
    { value: "Other", label: "Other" },
];

const ReviewReportModal = ({ open, handleClose, reviewData }) => {

    const closeModal = () => {
        setReportText("");
        setReportReason("")
        handleClose();
    };

    const [reportText, setReportText] = useState("");
    const [reportReason, setReportReason] = useState("");
    const [reportError, setReportError] = useState("");

    const [reportFeedback, { isLoading }] = useReportFeedbackMutation();

    // const handleReasonChange = (e) => {
    //     const value = e.target.value;

    //     setReportReason(value);
    //     setReportText(reportTemplates[value] || "");
    // };

    const handleReport = async () => {
        try {

            // Validate reason
            if (reportReason === "") {
                setReportError("Please select a reason.");
                return;
            }

            // // Validate textarea
            // if (!reportText.trim()) {
            //     setReportError("Please provide details.");
            //     return;
            // }

            setReportError("");

            await reportFeedback({
                id: reviewData?.id,
                body: {
                    report_text: reportText,
                    report_reason: reportReason
                }
            }).unwrap();

            setReportText("");
            setReportReason("All");
            closeModal();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Modal open={open} onClose={closeModal}>
            <Box className="review-report">
                {/* Header */}
                <Box className="review-report-header">
                    <Box>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                            <OutlinedFlag sx={{ color: "#dc2626" }} />
                            <Typography className="review-report-title">
                                Report Review to Management
                            </Typography>
                        </Box>

                        <Typography className="review-report-subtitle">
                            Flag this review as misleading, inappropriate, or violating guidelines. The management team will review your report.
                        </Typography>
                    </Box>

                    <IconButton onClick={closeModal}>
                        <Close />
                    </IconButton>
                </Box>

                {/* Feedback */}
                {reviewData?.description &&
                    <Box className="feedback-section">
                        <Typography className="feedback-title">
                            Review by {reviewData?.customer?.name}
                        </Typography>

                        <Typography className="feedback-text">
                            {reviewData?.description}
                        </Typography>
                    </Box>
                }

                {/* Report Section */}
                <Box Box className="report-section">
                    <Typography className="report-title">
                        Reason for Reporting
                    </Typography>

                    <CustomSelect
                        name="report"
                        placeholder="Select a reason"
                        value={reportReason}
                        options={reportOptions}
                        // onChange={handleReasonChange}
                        onChange={e => setReportReason(e.target.value)}
                        sx={{ borderRadius: '10px', backgroundColor: '#fff', fontSize: '14px', marginBottom: "15px" }}
                    />

                    <CustomTextArea
                        name="review-response"
                        minRows={4}
                        maxRows={5}
                        rows={4}
                        placeholder="Add more details about why this review should be investigated..."
                        // className="report-input"
                        value={reportText}
                        onChange={(e) => setReportText(e.target.value)}
                    // onChange={(e) => {
                    //     setReportText(e.target.value);
                    //     if (e.target.value.trim()) {
                    //         setReportError("");
                    //     }
                    // }}
                    />

                    {reportError && (
                        <Typography color="error" fontSize={12}>
                            {reportError}
                        </Typography>
                    )}

                    <Box className="report-btn-wrapper">
                        <Button
                            onClick={closeModal}
                            variant="outlined"
                            className="cancel-btn"
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={!reportText || isLoading}
                            onClick={handleReport}
                            variant="contained"
                            startIcon={<WarningAmberRounded />}
                            className="report-btn"
                        >
                            Submit Report
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal >
    );
};

export default ReviewReportModal;